import { useEffect, useState } from 'react';
import { Link } from 'react-router-dom';
import { PageHeader } from '@/components/layout/PageHeader';
import { deskApi } from '@/api/desk.api';
import { showApiError } from '@/utils/apiError';
import type { DeskBoardColumn } from '@/types/desk';

export function DeskBoardsPage() {
  const [columns, setColumns] = useState<DeskBoardColumn[]>([]);

  useEffect(() => {
    deskApi.board().then(setColumns).catch((err) => showApiError(err, 'Failed to load board'));
  }, []);

  return (
    <div>
      <PageHeader
        title="Desk Boards"
        description="Kanban view of tickets by workflow status"
        breadcrumbs={[{ label: 'Org', to: '/org' }, { label: 'Desk', to: '/desk' }, { label: 'Boards' }]}
      />
      <div className="flex gap-4 overflow-x-auto pb-4">
        {columns.map((col) => (
          <div key={col.statusId} className="min-w-[260px] flex-shrink-0 card p-3">
            <h3 className="font-semibold text-sm mb-3">
              {col.statusName} <span className="text-slate-500">({col.tickets.length})</span>
            </h3>
            <ul className="space-y-2">
              {col.tickets.map((t) => (
                <li key={t.id}>
                  <Link to={`/desk/tickets/${t.id}`} className="block rounded border border-slate-200 dark:border-slate-700 p-2 text-sm hover:border-primary-500">
                    <div className="font-medium truncate">{t.subject}</div>
                    <div className="text-xs text-slate-500">{t.ticketNumber}</div>
                  </Link>
                </li>
              ))}
            </ul>
          </div>
        ))}
      </div>
    </div>
  );
}
